<template>
   <div class="personFace">
        <div class="faceContain" v-if="!showCamera">
            <div class="faceTitle">
                请您进行人脸识别
            </div>
            <div style="padding-top: .1rem;color:#999">
                为保障您的交易安全，请先进行人脸识别
            </div>
            <div class="faceCon">
                <img src="./faceContain.png" alt="">
            </div>
            <div class="verifyBtn" @click="startCamera">
                开始验证
            </div>
        </div>
        <!-- 摄像头画面 + 倒计时 -->
        <div class="videoContain" v-else>
            <div class="faceTitle videoTitle">
                请面对摄像头，系统检测中
                <!-- <div class="countdown-tip">人脸识别中，{{ countdown }}秒后自动关闭</div> -->
            </div>
            <div class="face-container">
                <!-- 真实视频 -->
                <video
                    ref="video"
                    autoplay
                    playsinline
                    muted
                    webkit-playsinline
                    x5-video-player-type="h5"
                    x5-video-player-fullscreen="false"
                    class="face-video"
                ></video>                
                <!-- CSS 绘制的人脸框 -->
                <div class="face-outline"></div>
            </div>
            <div class="face-ellipse"></div>
        </div>

        <van-popup
            style="border-radius: 0.08rem;width:80%"
            v-model="isCountdown"
            :close-on-click-overlay="false"
            >
            <div class="countCon">
                <img src="./faceError.png" alt="" style="width: 1.78rem;">
                <div class="countTitle">人脸识别不通过</div>
                <p>请核实是否为被保险人本人</p>
                <div class="confirmBtn" @click="errorConfirm">确定</div>
            </div>
            </van-popup>
        </div>
</template>

<script>
    export default {
        data() {
            return {
                showCamera: false, // 是否展示摄像头
                stream: null, // 媒体流
                countdown: 10, // 倒计时秒数
                countdownTimer: null, // 每秒更新定时器
                closeTimer: null, // 10秒后自动关闭定时器
                isCountdown: false
            }
        },
        mounted() {
            console.log('mounted')
        },
        activated() {
           console.log('activated')
           this.$store.commit('set_showStep', false)
           console.log(this.$route.query.isMotorFace, 'query')
           this.isCountdown = false
        },
        beforeDestroy() {
            // 页面销毁时强制关闭摄像头
            this.stopCamera()
        },
        methods: {
            errorConfirm() {
                this.isCountdown = false
                // this.$store.commit('set_motorStep', '2')
                this.$router.replace({
                    name: 'PersonInfo'
                })
            },
            /* ---------- 开启前置摄像头 ---------- */
            async startCamera() {
                // 检测浏览器能力
                if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                    alert('当前浏览器不支持摄像头调用，请使用现代浏览器');
                    return;
                } else {
                    try {
                        // 强制使用前置摄像头
                        const constraints = {
                            video: {
                                facingMode: 'user', // 前置摄像头
                                width: { ideal: 1280 },
                                height: { ideal: 720 }
                            },
                            audio: false
                        };
                        this.stream = await navigator.mediaDevices.getUserMedia(constraints);

                        // 显示视频并初始化倒计时
                        this.showCamera = true;
                        this.countdown = this.$route.query.isMotorFace === '0' ? 3 : 10

                        // // 绑定视频流（等 DOM 更新后）
                        this.$nextTick(() => {
                        const video = this.$refs.video;
                            if (video) {
                                video.srcObject = this.stream;
                                video.play().catch(e => console.warn('自动播放异常：', e));
                            }
                        });

                        // 每秒更新倒计时
                        this.countdownTimer = setInterval(() => {
                            if (this.countdown > 0) {
                                this.countdown--;
                            } else {
                                this.stopCamera();
                            }
                        }, 1000);

                        // 10秒后强制关闭（双保险）
                        this.closeTimer = setTimeout(() => {
                        this.stopCamera();
                        // Toast({
                        //     message: '人脸识别失败',
                        //     duration: 3000,
                        // });
                        }, 10000);
                    } catch (err) {
                        console.error('摄像头调用失败:', err);
                        if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
                            alert('摄像头权限被拒绝，请在系统设置中允许访问');
                        } else if (err.name === 'NotFoundError' || err.name === 'DevicesNotFoundError') {
                            alert('未检测到前置摄像头');
                        } else if (err.name === 'NotReadableError' || err.name === 'TrackStartError') {
                         alert('摄像头被占用，请关闭其他应用后重试');
                        } else {
                            alert('摄像头启动失败：' + err.message);
                        }
                        this.showCamera = false;
                    }
                }
                },
            /* ---------- 关闭摄像头 ---------- */
            stopCamera() {
                if (this.stream) {
                    this.stream.getTracks().forEach(track => track.stop());
                    this.stream = null;
                }
                if (this.closeTimer) {
                    clearTimeout(this.closeTimer);
                    this.closeTimer = null;
                }
                if (this.countdownTimer) {
                    clearInterval(this.countdownTimer);
                    this.countdownTimer = null;
                }
                this.showCamera = false;
                if (this.$route.query.isMotorFace === '0') {
                    this.$store.commit('set_motorStep', '3')
                } else {
                    this.isCountdown = true;
                }
            },
        }
    }
</script>
<style lang="scss" scoped>
 @import './personFace.scss';
</style>



// WEBPACK FOOTER //
// src/pages/motor/components/personInfo/personFace/index.vue